import React from 'react';
import NotificationsPage from '../MasterAdmin/NotificationsPage';

/** Writer-scoped notifications feed (reuses shared NotificationsPage). */
const WriterNotificationsPage: React.FC = () => <NotificationsPage audience="writer" />;

export default WriterNotificationsPage;
